import { render, staticRenderFns } from "./ExtraDetails.vue?vue&type=template&id=114b042f&"
import script from "./ExtraDetails.vue?vue&type=script&lang=js&"
export * from "./ExtraDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports